const country = {
  getlist: 'country/getlist',
  add: 'country/add',
  update: 'country/update',
  remove: 'country/remove',
  get: 'country/get',
  getall: 'country/getall',
}
export default country
